// eApp_EditableText.js
import React, { useState } from 'react';
import { Edit2 } from 'lucide-react';

const EditableText = ({ value, onChange, multiline = false }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempValue, setTempValue] = useState(value);

  const handleBlur = () => {
    onChange(tempValue);
    setIsEditing(false);
  };

  if (isEditing) {
    return multiline ? (
      <textarea
        value={tempValue}
        onChange={(e) => setTempValue(e.target.value)}
        onBlur={handleBlur}
        className="w-full p-2 border border-[#E0E0E0] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F0EAE2]"
        autoFocus
        onClick={(e) => e.stopPropagation()}  // Prevent click propagation
      />
    ) : (
      <input
        type="text"
        value={tempValue}
        onChange={(e) => setTempValue(e.target.value)}
        onBlur={handleBlur}
        className="w-full p-2 border border-[#E0E0E0] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F0EAE2]"
        autoFocus
        onClick={(e) => e.stopPropagation()}  // Prevent click propagation
      />
    );
  }

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();  // Prevent click propagation
        setIsEditing(true);
      }}
      className="cursor-pointer hover:bg-[#F0EAE2] p-1 rounded"
    >
      {multiline ? <p>{value}</p> : <h3 className="font-semibold">{value}</h3>}
      <Edit2 size={16} className="inline ml-2 text-[#666666]" />
    </div>
  );

};

export default EditableText;
